export default {"src":"/_next/static/media/ALB.0888d47f.svg","height":18,"width":18};